import { strings } from "../i18n/strings.es-AR.js";
import { getEntry } from "../hooks/useConversation.js";
import {
  appInstalled,
  installHintOnly,
  installPromptAvailable,
  isIosSafari,
  promptInstall
} from "../push/installPrompt.js";
import { track } from "../metrics/track.js";
import { Icon } from "./icons.jsx";

// Ofrece instalar la PWA de forma permanente MIENTRAS NO esté instalada: sin
// "ahora no" persistido y sin esperar la primera interacción. Se oculta sola
// cuando la app corre instalada (appInstalled) y en modo widget embebido.
export function InstallBanner() {
  const iosManual = isIosSafari();
  // Con diálogo nativo se muestra el botón; si no, instrucciones para instalar
  // a mano. Sin ninguno de los dos caminos no hay nada útil que decir.
  const canPrompt = installPromptAvailable.value;
  const showHint = installHintOnly.value || iosManual;

  const visible =
    !appInstalled.value &&
    getEntry().mode !== "widget" &&
    (canPrompt || showHint);
  if (!visible) return null;

  const onInstall = async () => {
    const outcome = await promptInstall();
    track("pwa_install_prompt", { outcome });
  };

  return (
    <div class="bg-white px-4 py-2 text-xs text-flux-navy shadow-sm dark:bg-slate-800 dark:text-slate-100">
      <div class="chat-col flex items-center gap-2">
      <Icon name="download" size={15} class="shrink-0 text-flux-primary dark:text-flux-cyan" />
      <span class="min-w-0 flex-1">
        {canPrompt
          ? strings.installBannerText
          : iosManual
            ? strings.installHintIos
            : strings.installHintBrowser}
      </span>
      {canPrompt && (
        <button
          type="button"
          class="shrink-0 rounded-full bg-flux-primary px-3 py-1 font-medium text-white"
          onClick={onInstall}
        >
          {strings.installAction}
        </button>
      )}
      </div>
    </div>
  );
}
